import type { PortalAudience } from '@/access/portalAccess.types';
import type { SitesViewInput } from '@/modules/sites/sites.viewInput';

export type SitesListQueryType = 'clientSites';

export type SitesListView = {
  audience: PortalAudience;
  actions: {
    showAddSite: boolean;
    showEditSite: boolean;
  };
  query: {
    sites: {
      strategy: SitesListQueryType;
    };
  };
};

export const getSitesListView = ({ access }: SitesViewInput): SitesListView => {
  const { audience } = access;

  return {
    audience,
    actions: {
      showAddSite: true, // show the add site button to the client AND the tenant for now.
      showEditSite: true, // show the edit site button to the client AND the tenant for now.
    },
    query: {
      sites: {
        strategy: 'clientSites',
      },
    },
  };
};
